import { Button, DatePicker, Form, Input, message, Select, Upload } from 'antd';
const { Option } = Select;
// import { FilterPayload } from 'api/dashboard';
import MandateList from '../lisat/MandateList';
import {
  getMandateApproveList,
  MandateApproveFilterPayload,
  MandateApprovePagedList,
  uploadMandateApprove,
} from 'api/nach';
import { useCallback, useEffect, useState } from 'react';
import { download, generateCsv, mkConfig } from 'export-to-csv';
import axios from 'axios';
import { getSelectList, SelectPayload, SelectResponse } from 'api/dashboard';
import Loading from 'features/nach/components/Loading';

const dateFormat = 'DD/MM/YYYY';
// type Props = {
//   isLoading: boolean;
//   onSubmit: (values: MandateApproveFilterPayload) => Promise<void>;
// };
const initSelectResp: SelectResponse = {
  data: [],
};
let mandateApproveFilterPayload: MandateApproveFilterPayload = {};
let mandateApprovePagedList: MandateApprovePagedList;

function MandateDashboardForm() {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm<MandateApproveFilterPayload>();
  const [filter, setFilter] = useState(mandateApproveFilterPayload);
  const [mandateData, setMandateData] = useState(mandateApprovePagedList);
  const [sources, setSource] = useState(initSelectResp);
  const [_sourceId, setSourceId] = useState(0);

  useEffect(() => {
    const payloadData: MandateApproveFilterPayload = {
      isExtract: false,
      pageNo: 1,
      pageSize: 10,
    };

    getMandateApproveList(payloadData).then((res) => {
      if (res.status == 'SUCCESS' && res.data) {
        setMandateData(res.data);
        console.log('getMandateApproveList called');
      }
      console.log('Response', res);
    });
  }, []);

  console.log(isLoading, mandateData);

  useEffect(() => {
    const sourcePayload: SelectPayload = {
      SKey: 'Source',
    };
    getSelectList(sourcePayload).then((res) => {
      setSource(res);
    });
    // }
  }, []);

  const handleUpload = useCallback(async (file: any) => {
    // ... (initial validations)

    const reader = new FileReader();
    reader.onload = async () => {
      const content = reader.result as string;

      // Split content by new lines to get rows
      const rows = content.trim().split(/\r?\n/);

      // Check header row
      const headerRow = rows[0];
      const dataRows = rows.slice(1); // Skip header row

      // Combine header and data rows for delimiter detection, filtering out undefined or empty values
      // const combinedRows = [headerRow, ...dataRows.filter((row): row is string => !!row)];
      const combinedRows = [headerRow, ...dataRows];

      // Detect delimiter based on the presence of tab or comma in all rows
      const delimiter = combinedRows.some((row) => row?.includes('\t')) ? '\t' : ',';

      console.log('Detected delimiter:', delimiter); // Log the detected delimiter

      // Process each data row and convert tab-separated values to comma-separated
      const processedDataRows = dataRows.map((row) => {
        const trimmedRow = row.trim(); // Trim any extra spaces
        return trimmedRow.split(delimiter).join(','); // Convert to comma-separated
      });

      // Log processed data rows to verify conversion
      // console.log('Processed Data Rows:', processedDataRows);

      // Create a Blob from the processed data
      const blob = new Blob([headerRow + '\n' + processedDataRows.join('\n')], {
        type: 'text/csv',
      });
      // console.log('bolb', blob);

      // Create FormData object for uploading
      const formdata = new FormData();
      formdata.append('presentmentFile', blob, 'processed_data.csv'); // Use blob instead of original file

      setIsLoading(true);

      try {
        const response = await axios.post(uploadMandateApprove, formdata);
        if (response.status === 200) {
          message.success('Success');
          // Refresh or navigate as needed
        }
      } catch (error) {
        // console.error(error);
        message.error('Failed to upload data!!');
      } finally {
        setIsLoading(false);
      }
    };

    reader.readAsText(file);
  }, []);

  function handleDownload() {
    debugger;
    const values: MandateApproveFilterPayload = form.getFieldsValue();
    const payloadData: MandateApproveFilterPayload = {
      ...values,
      isExtract: true,
      pageNo: 1,
      pageSize: 10,
    };
    getMandateApproveList(payloadData)
      .then((res) => {
        console.log('Fetched data from MandateApproveList:', res);

        const bulkUploadRequestList = res.data?.data || [];
        const formattedData = bulkUploadRequestList.map((item) => ({
          MandateID: item.mandateId,
          LoanNumber: item.loanNo,
          SourceApplicationName: item.sourceApplicationName,
          'DisbursementCompleted(yes/no)': '',
        }));

        const fileName = `Mandate Data - ${new Date().toLocaleDateString()}`;
        const csvConfig = mkConfig({ useKeysAsHeaders: true, filename: fileName });
        const csv = generateCsv(csvConfig)(formattedData);
        download(csvConfig)(csv);
      })
      .catch((error) => {
        console.error('Error fetching mandate approve list:', error);
      });
  }
  const handleSubmit = useCallback(
    async (values: MandateApproveFilterPayload) => {
      debugger;
      let updatedValues = { ...values };
      Object.keys(updatedValues).forEach((key) => {
        const typedKey = key as keyof MandateApproveFilterPayload; // Cast the key to a valid key of FilterPayload
        if (updatedValues[typedKey] === '') {
          updatedValues[typedKey] = null;
        }
      });
      setFilter(updatedValues);
      console.log('filter Values', filter);
    },
    [onsubmit, form]
  );

  const handleSourceId = (e: any) => {
    form.setFieldValue('sourceId', e);
    form.validateFields(['sourceId']);
    setSourceId(Number(e));
  };
  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = mandateApproveFilterPayload;
    setFilter(updatedFilter);
  }
  // console.log('Response ', mandateData);

  return (
    <div>
      <Loading isLoading={isLoading} />
      <Form<MandateApproveFilterPayload>
        layout="vertical"
        scrollToFirstError
        className="standard-forms"
        onFinish={handleSubmit}
        form={form}
      >
        <div className="row">
          <div className="col-xs-12 col-sm-4 col-md-4">
            <div className="input-box">
              <Form.Item label={'Mandate Request ID :'} name="mandateId" className="fieldTitle">
                <Input placeholder={'Enter Mandate ID'} />
              </Form.Item>
            </div>
          </div>
          <div className="col-xs-12 col-sm-4 col-md-4">
            <div className="input-box">
              <Form.Item label={'Loan No :'} name="lanNumber" className="fieldTitle">
                <Input placeholder={'Enter Loan No'} />
              </Form.Item>
            </div>
          </div>
          <div className="col-xs-12 col-sm-4 col-md-4">
            <div className="input-box">
              <Form.Item
                label={'Source Application Name :'}
                name="sourceApplicationName"
                className="fieldTitle"
              >
                <Select
                  placeholder="Select"
                  size="large"
                  // value={statusId.toString()}
                  onSelect={handleSourceId}
                >
                  {/* <Option value="0">Select</Option> */}
                  {sources.data.map((role) => (
                    <Option value={role.SText}>{role.SText}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </div>
          <div className="col-xs-12 col-sm-4 col-md-4">
            <div className="input-box">
              <Form.Item
                label={'Mandate Request Date From:'}
                name="fromDate"
                className="fieldTitle"
              >
                <DatePicker placeholder={'Select From Date'} format={dateFormat} />
              </Form.Item>
            </div>
          </div>
          <div className="col-xs-12 col-sm-4 col-md-4">
            <div className="input-box">
              <Form.Item
                label={'To :'}
                rules={[
                  {
                    validator(rule, value, callback) {
                      if (value < form.getFieldValue('fromDate')) {
                        rule.message = 'To Date should be greater than From Date';
                        callback('To Date should be greater than From Date');
                      } else {
                        callback();
                      }
                    },
                  },
                ]}
                name="toDate"
                className="fieldTitle"
              >
                <DatePicker format={dateFormat} placeholder={'Select To Date'} />
              </Form.Item>
            </div>
          </div>
          <div style={{ float: 'right', marginBottom: '10px', marginTop: '30px' }}>
            <Button
              type="primary"
              onClick={handleReset}
              style={{ float: 'right', marginRight: '5px' }}
            >
              {'CLEAR'}
            </Button>
            &nbsp; &nbsp;
            <Button
              type="primary"
              htmlType="submit"
              style={{ float: 'right', marginRight: '10px' }}
            >
              {'SEARCH'}
            </Button>
            &nbsp; &nbsp;
            <Button
              type="primary"
              onClick={handleDownload}
              style={{ float: 'right', marginRight: '10px' }}
            >
              {'DOWNLOAD'}
            </Button>
            &nbsp; &nbsp;
            <div className="uploadButton " style={{ float: 'right', marginRight: '10px' }}>
              <Upload accept=".csv" beforeUpload={handleUpload} showUploadList={false}>
                <Button type="primary">{'UPLOAD'}</Button>
              </Upload>
            </div>
          </div>
        </div>
      </Form>
      <MandateList filter={{ ...filter }} />
    </div>
  );
}

export default MandateDashboardForm;
